module.exports = require("onnxruntime-common");